export const legacyStrings = {
  New_Feature_Label_NewUI: _TL_('New'),
};
